module.exports = __webpack_public_path__ + "static/media/tenappearances.7a66e5fc.jpg";